import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initPixel } from './lib/pixel';
function Root() {
  useEffect(() => {
    initPixel();
  }, []);
  return <App data-id="element-429" />;
}
render(<Root data-id="element-430" />, document.getElementById('root'));